import { apiHelpers } from '../utils/api';
import {
  Item,
  CreateItemData,
  UpdateItemData,
  ItemStats,
  ItemsResponse,
  ItemFilters
} from '../types/item';

export const itemService = {
  async getItems(filters: ItemFilters = {}): Promise<ItemsResponse> {
    const params = new URLSearchParams();
    
    if (filters.search) params.append('search', filters.search);
    if (filters.isActive !== undefined) params.append('isActive', String(filters.isActive));
    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));

    return await apiHelpers.get(`/items?${params.toString()}`);
  },

  async getItem(id: string): Promise<Item> {
    return await apiHelpers.get(`/items/${id}`);
  },

  async createItem(data: CreateItemData): Promise<Item> {
    return await apiHelpers.post('/items', data);
  },

  async updateItem(id: string, data: UpdateItemData): Promise<Item> {
    return await apiHelpers.put(`/items/${id}`, data);
  },

  async deleteItem(id: string): Promise<void> {
    return await apiHelpers.delete(`/items/${id}`);
  },

  async getItemStats(): Promise<ItemStats> {
    return await apiHelpers.get('/items/stats');
  }
};